<template>
  <el-container>
    <el-main>
      <div style="margin-bottom: 20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="item_font">设置客服及权限</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="menu">
        <el-tabs v-model="menu" @tab-click="handleClick" type="card">
          <el-tab-pane label="员工列表" name="emp"></el-tab-pane>
          <el-tab-pane label="部门列表" name="dep"></el-tab-pane>
          <el-tab-pane label="角色管理" name="role"></el-tab-pane>
          <el-tab-pane label="微信绑定管理" name="wechat"></el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="menu == 'emp'">
        <EmployeeList
          :tableData="tableDataEmployee"
          :tableDataRole="tableDataRole"
          :departmentLst="departmentLst"
          @searchFather="searchFather"
          @delet="delet"
          @condirmAdd="condirmAdd"
          @confirmEdit="confirmEdit"
          @roleSearch="roleSearch"
          @roleRestart="roleRestart"
          @clickPage="clickPage"
          :total="total"
        ></EmployeeList>
      </div>
      <div v-if="menu == 'dep'">
        <DepartmentList></DepartmentList>
      </div>
      <div v-if="menu == 'role'">
        <RoleSet
          :tableData="tableDataRole"
          :permissionLst="permissionLst"
          :titlePermission="titlePermission"
          :textPermission="textPermission"
          :valueBoo="valueBoo"
          :titleID="titleID"
          :roleTotal="roleTotal"
          @addPermission="addPermission"
          @delet="delet"
          @condirmAdd="condirmAdd"
          @confirmEdit="confirmEdit"
          @roleSearch="roleSearch"
          @roleRestart="roleRestart"
          @clickPage="clickPage"
        ></RoleSet>
      </div>
      <div v-if="menu == 'wechat'">
        <el-table
          :data="wechatData"
          stripe
          border
          highlight-current-row
          style="width: 95%"
          :max-height="maxHeight()"
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
        >
          <el-table-column
            prop="realName"
            label="真实姓名"
            width="200"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="loginName" label="登录名"> </el-table-column>
          <el-table-column prop="wechatNickName" label="微信昵称">
          </el-table-column>
          <el-table-column prop="tel" label="电话"> </el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="unbinded(scope.row)"
                >解绑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import EmployeeList from "../../components/EmployeeList/index.js";
import RoleSet from "../../components/RoleSet/index.js";
import DepartmentList from "../../components/DepartmentList/index.js";
import { MessageBox } from "element-ui";
import { maxHeight } from "../../utils/tableHeight";
// import axios from 'axios'
export default {
  data() {
    return {
      tableDataEmployee: [],
      formEmployee: {
        name: "",
        nicknam: "",
        phone: "",
        department: "",
        state: "open",
        role: "",
      },
      tableDataRole: [],
      permissionLst: [],
      formRole: {
        name: "",
        nicknam: "",
        phone: "",
        department: "",
        state: "open",
        role: "",
      },
      menu: "emp",
      realName: "",
      roleName: "",
      id: "",
      titlePermission: [],
      titleID: [],
      textPermission: [],
      roleId: "",
      valueBoo: [],
      departmentLst: [],
      page: 1,
      total: 0,
      rolePage: 1,
      roleTotal: 0,
      wechatData: [],
    };
  },
  components: {
    EmployeeList,
    RoleSet,
    DepartmentList,
  },
  mounted() {
    const account = JSON.parse(localStorage.getItem("account"));
    // this.realName = account.realName
    this.id = account.id;
    console.log("account", account);
    this.employeeSelect();
    this.roleSelect();
    this.departmentSelect();
  },
  methods: {
    maxHeight, //表格高度自适应
    async employeeSelect() {
      console.log("当前页码数：*******", this.page);
      var api = "/manager/user/selectPage";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          current: this.page,
          roleName: this.realName,
          size: 10,
        },
      });
      this.total = response.data.count;
      this.tableDataEmployee = response.data.userSelectVoList;
      console.log("employeeSelect response = ", response.data);
      for (var i = 0; i < this.tableDataEmployee.length; i++) {
        if (
          this.tableDataEmployee[i].endTime != null ||
          this.tableDataEmployee[i].endTime != undefined
        ) {
          var end = this.util.timeStampToDate(
            this.tableDataEmployee[i].endTime,
            0
          );
          this.tableDataEmployee[i].endTime = end;
        }
        if (
          this.tableDataEmployee[i].createTime != null ||
          this.tableDataEmployee[i].createTime != undefined
        ) {
          var create = this.util.timeStampToDate(
            this.tableDataEmployee[i].createTime,
            0
          );
          this.tableDataEmployee[i].createTime = create;
        }
      }
      for (var k = 0; k < this.tableDataEmployee.length; k++) {
        if (
          this.tableDataEmployee[k].status == "1" ||
          this.tableDataEmployee[k].status == 1
        ) {
          // this.tableDataEmployee[k].status ='可用'
          this.tableDataEmployee[k].isCanuse = "可用";
        } else if (
          this.tableDataEmployee[k].status == "0" ||
          this.tableDataEmployee[k].status == 0
        ) {
          // this.tableDataEmployee[k].status = '不可用'
          this.tableDataEmployee[k].isCanuse = "不可用";
        }
      }
      // console.log('时间转换',response.count)
    },
    async employeeEdit(editForm) {
      console.log("employeeEdit editForm", editForm);
      this.employeeSelect();
      // var api = "/manager/user/edit";
      // const response =await this.util.postRequest({
      // 	url: api,
      // 	method: "POST",
      // 	data: {
      // 		id:editForm.id,
      // 		realName:editForm.realName,
      // 		loginName:editForm.loginName,
      // 		tel:editForm.tel,
      // 		depId:editForm.depId,
      // 		roleId:editForm.roleId,
      // 		status:editForm.status,
      // 		wechatNumber:editForm.wechatNumber
      // 	},
      // });
      // console.log("employeeEdit response = ", response);

      // if(response.resultCode==="10000"){
      // 	this.open1()
      // }else{
      // 	this.open2(response.desc)
      // }
    },
    async employeeDel(id) {
      var api = "/manager/user/del";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: id,
        },
      });
      console.log("employeeDel response = ", response);
      // this.page=1
      this.employeeSelect();
      if (response.resultCode === "10000") {
        this.open3();
      } else {
        this.open2(response.desc);
      }
    },
    async roleSelect() {
      var api = "/manager/role/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          current: this.rolePage,
          roleName: this.roleName,
          size: 10,
        },
      });
      this.roleTotal = response.data.count;
      this.tableDataRole = response.data.roleList;
      console.log("roleSelect response = ", response.data);
    },
    async roleEdit(editForm) {
      var api = "/manager/role/edit";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: editForm.id,
          roleName: editForm.roleName,
          remark: editForm.remark,
        },
      });
      console.log("roleEdit response = ", response.data);
      this.roleSelect();
      if (response.resultCode === "10000") {
        this.open1();
      } else {
        this.open2(response.desc);
      }
    },
    async roleDel(id) {
      var api = "/manager/role/del";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: id,
        },
      });
      console.log("roleDel response = ", response);
      if (response.resultCode == 40000) {
        this.$message.error(response.desc);
        return;
      }
      // this.rolePage=1
      this.open3();
      this.roleSelect();
    },
    async selectPermission(id) {
      console.log("当前用户id", id);
      var api = "/manager/permission/toAssign/" + id;
      const response = await this.util.postRequest({
        url: api,
        method: "GET",
      });
      this.valueBoo = [];
      console.log("selectPermission response = ", response.data);
      var data = response.data.data;
      for (var c = 0; c < data.length; c++) {
        // 处理父权限值的数组
        this.valueBoo.push(data[c].seLect);
      }
      console.log("this.valueBoo", this.valueBoo);
      var textArr = []; // 权限数据结构
      this.titlePermission = []; // 父权限名字
      this.textPermission = []; // 子权限
      for (var i = 0; i < data.length; i++) {
        // 获取权限数据结构：textArr； 父权限名字数组：this.titlePermission，titleID：父权限id
        var arr1 = [];
        if (data[i].name === "对话管理") {
          // 处理对话管理权限结构
          console.log("对话管理:", data[i]);
          var arr11 = data[i].permi1VoList[0];
          var arr22 = data[i].permi1VoList[1];
          arr1.push(arr11);
          arr1.push(arr22);
          textArr.push(arr1);
          this.titlePermission.push(data[i].name);
          this.titleID.push(data[i].id);
        } else {
          arr1 = data[i].permi1VoList[0];
          this.titlePermission.push(data[i].name);
          this.titleID.push(data[i].id);
          textArr.push(arr1);
        }
      }
      console.log("textArr", textArr);
      console.log("this.titlePermission", this.titlePermission);
      for (var k = 0; k < textArr.length; k++) {
        // 获取子权限数组：this.textPermission；
        if (textArr[k] === undefined) {
          this.textPermission.push([]);
        } else {
          if (this.titlePermission[k] == "对话管理") {
            var arr2;
            arr2 = textArr[k];
            // console.log("我的会话：",textArr[k], textArr[k].permiList)
            this.textPermission.push(arr2);
          } else {
            var arr3;
            arr3 = textArr[k].permiList;
            this.textPermission.push(arr3);
          }
        }
      }

      console.log("this.textPermission", this.textPermission);
    },
    async rolePermission(arr) {
      var api = "/manager/permission/doAssign";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          roleId: this.roleId,
          permissionId: arr,
        },
      });
      console.log("rolePermission response = ", response);
      if (response.resultCode === "10000") {
        this.open1();
        this.getAuthorityRequest();
      } else {
        this.open2(response.desc);
      }
    },

    setDefaultSetting() {
      console.log("msgCodeBox setDefaultSetting");
      var tempObj = {};
      tempObj.endChat = false;
      tempObj.disturb = false;
      tempObj.transter = false;
      tempObj.markTag = false;
      tempObj.defriend = false;
      tempObj.adapter = false;
      tempObj.colleage = false;
      tempObj.trouble = false;
      tempObj.personPmtList = [];
      tempObj.systemPmtList = [];
      tempObj.midmanPmtList = [];
      tempObj.loginmgList = [];
      tempObj.log = false;
      tempObj.word = false;
      tempObj.record = false;
      tempObj.bot = false;
      tempObj.transterTa = false;
      tempObj.downHtml = false;
      tempObj.quickShow = false;
      tempObj.publicQuickShow = false;
      this.util.setLocalPermit(JSON.stringify(tempObj));
    },

    async getAuthorityRequest() {
      console.log("msgCodeBox getAuthorityRequest");
      var api = "/manager/permission/getPermissionList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("msgCodeBox getAuthorityRequest response = ", response);
      if (response.resultCode === "10000") {
        this.setDefaultSetting();
        var tempObj = this.util.getLocalPermintObj();
        for (var i = 0; i < response.data.length; i++) {
          const chatPermi = response.data[i];
          if (chatPermi.name === "对话管理") {
            const permiList = chatPermi.permiVoList;
            for (var j = 0; j < permiList.length; j++) {
              var permit = permiList[j];
              if (permit.name === "关闭会话") {
                tempObj.endChat = permit.status == 1 ? true : false;
              } else if (permit.name === "勿扰设置") {
                tempObj.disturb = permit.status == 1 ? true : false;
              } else if (permit.name === "转接会话") {
                tempObj.transter = permit.status == 1 ? true : false;
              } else if (permit.name === "打标签") {
                tempObj.markTag = permit.status == 1 ? true : false;
              } else if (permit.name === "添加黑名单") {
                tempObj.defriend = permit.status == 1 ? true : false;
              } else if (permit.name === "接管会话") {
                tempObj.adapter = permit.status == 1 ? true : false;
              } else if (permit.name === "我的同事") {
                tempObj.colleage = permit.status == 1 ? true : false;
              } else if (permit.name === "疑似骚扰用户") {
                tempObj.trouble = permit.status == 1 ? true : false;
              } else if (permit.name === "转接给他人") {
                tempObj.transterTa = permit.status == 1 ? true : false;
              } else if (permit.name == "在线访客列表") {
                tempObj.isOnlineList = permit.status == 1 ? true : false;
              } else if (permit.name == "同事快捷回复展现") {
                tempObj.quickShow = permit.status == 1 ? true : false;
              } else if (permit.name == "公共快捷回复展现") {
                tempObj.publicQuickShow = permit.status == 1 ? true : false;
              } else if (permit.name == "已离开（未结束）列表") {
                tempObj.isOnlineOffList = permit.status == 1 ? true : false;
              }
            }
          } else if (chatPermi.name === "个人设置") {
            tempObj.personPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          } else if (chatPermi.name === "系统设置") {
            tempObj.systemPmtList = this.util.normalizeSystemPmtList(
              chatPermi.permiVoList
            );
          } else if (chatPermi.name === "日志管理") {
            tempObj.log = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "留言管理") {
            tempObj.word = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "对话记录") {
            tempObj.record = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "开口机器人") {
            tempObj.bot = chatPermi.status == 1 ? true : false;
          } else if (chatPermi.name === "报表管理") {
            const permiList = chatPermi.permiVoList;
            for (var o = 0; o < permiList.length; o++) {
              var permit1 = permiList[o];
              if (permit1.name === "HTML报表下载") {
                tempObj.downHtml = permit1.status == 1 ? true : false;
              }
            }
          } else if (chatPermi.name === "Middleman管理") {
            tempObj.midmanPmtList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          } else if (chatPermi.name === "登录管理") {
            tempObj.loginmgList = chatPermi.permiVoList.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
          }
        }

        this.util.setLocalPermit(JSON.stringify(tempObj));

        this.$store.state.authority.isShowLog = this.util.getLocalPermit("log");
        this.$store.state.authority.isShowWord =
          this.util.getLocalPermit("word");
        this.$store.state.authority.isColleague =
          this.util.getLocalPermit("colleage");
        this.$store.state.authority.isTrouble =
          this.util.getLocalPermit("trouble");
        this.$store.state.authority.isEndChat =
          this.util.getLocalPermit("endChat");
        this.$store.state.authority.isTransfer =
          this.util.getLocalPermit("transter");
        this.$store.state.authority.isDefriend =
          this.util.getLocalPermit("defriend");
        this.$store.state.authority.isAdapter =
          this.util.getLocalPermit("adapter");
        this.$store.state.authority.isDisturb =
          this.util.getLocalPermit("disturb");
        this.$store.state.authority.isMarkTag =
          this.util.getLocalPermit("markTag");
        this.$store.state.authority.isShowBot = this.util.getLocalPermit("bot");
        this.$store.state.authority.isShowRecord =
          this.util.getLocalPermit("record");
        this.$store.state.authority.isOnlineList =
          this.util.getLocalPermit("isOnlineList");
        this.$store.state.authority.isOnlineOffList =
          this.util.getLocalPermit("isOnlineOffList");
        this.$store.state.authority.isTransferTa =
          this.util.getLocalPermit("transterTa");
        this.$store.state.authority.isDownHtml =
          this.util.getLocalPermit("downHtml");
        this.$store.state.authority.personList =
          this.util.getLocalPermit("personPmtList");
        this.$store.state.authority.systemList =
          this.util.getLocalPermit("systemPmtList");
        this.$store.state.authority.midmanList =
          this.util.getLocalPermit("midmanPmtList");
        this.$store.state.authority.loginmg =
          this.util.getLocalPermit("loginmgList");
        this.$store.state.authority.isQuickShow =
          this.util.getLocalPermit("quickShow");
          this.$store.state.authority.isPublicQuickShow =
          this.util.getLocalPermit("publicQuickShow");
      } else {
        this.$message.error(response.desc);
      }
    },

    async departmentSelect() {
      // 部门查询
      var api = "/manager/dep/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: "",
        },
      });
      console.log("departmentSelect response = ", response.data);
      for (var i = 0; i < response.data.length; i++) {
        this.getTree(response.data[i]);
      }
      this.departmentLst = response.data;
    },
    getTree(data) {
      data.children = data.depVoList;
      data.label = data.depName;
      data.value = data.id;
      // data.pid = data.pid
      if (data.children != null) {
        for (var i = 0; i < data.children.length; i++) {
          this.getTree(data.children[i]);
        }
      }
    },
    handleClick(tab) {
      console.log("选择菜单：", tab.name);
      this.menu = tab.name;
      if (tab.name == "emp") {
        this.page = 1;
        this.realName = "";
        this.employeeSelect();
        this.departmentSelect();
      } else if (tab.name == "role") {
        this.rolePage = 1;
        this.roleName = "";
        this.roleSelect();
        this.departmentSelect();
      } else if (tab.name == "wechat") {
        this.getBinderRequest();
      }
    },

    headerStyle({ rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 5) {
        return "text-align:center;color:#000000";
      } else {
        return "text-align:left;padding:15px;color:#000000";
      }
    },

    cellStyle({ columnIndex }) {
      if (columnIndex == 5) {
        return "text-align:center";
      } else {
        return "text-align:left;padding:15px;";
      }
    },

    async getBinderRequest() {
      var api = "/manager/weixin/getBindingWechatUserList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      this.wechatData = [];

      if (response.resultCode == 10000) {
        this.wechatData = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },

    unbinded(row) {
      var tipstr = "你确定解绑" + row.realName + "的微信登录账号吗？";
      this.$confirm(tipstr, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.unbindedRequest(row);
        })
        .catch(() => {
          console.log("unbindAction catch");
        });
    },

    async unbindedRequest(binder) {
      console.log("unbindedRequest binderid = ", binder.id);
      var api = "/manager/weixin/unBindingWechatUser/" + binder.id;
      const response = await this.util.postRequest({
        url: api,
        method: "GET",
      });

      if (response.resultCode == 10000) {
        this.getBinderRequest();
        this.$message("解绑成功");
      } else {
        this.$message.error(response.desc);
      }
    },

    addPermission(info) {
      console.log("查询当前用户的权限菜单", info);
      this.roleId = info.roleData.id;
      this.selectPermission(info.roleData.id);
    },
    delet(info) {
      console.log("父组件删除", info);
      if (info.tableName == "employee") {
        const tipMsg = "是否确认删除";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          showCancelButton: true,
        }).then(() => {
          this.page = info.page;
          console.log("设置当前页码未*********", this.page);
          this.employeeDel(info.editForm.id);
        });
      } else if (info.tableName == "role") {
        const tipMsg = "是否确认删除";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          showCancelButton: true,
        }).then(() => {
          this.page = info.page;
          console.log("设置当前页码未*********", this.page);
          this.roleDel(info.editForm.id);
        });
      }
    },
    condirmAdd(info) {
      this.page = info.page;
      console.log("父组件添加", info);
      if (info.tableName == "employee") {
        this.employeeEdit(info.form);
      } else if (info.tableName == "role") {
        console.log("角色添加");
        var arr = [];
        // var arr1=[]
        for (var j = 0; j < info.valueBoo.length; j++) {
          // console.log(info.valueBoo[j])
          if (info.valueBoo[j] == true) {
            arr.push(this.titleID[j]);
          }
        }
        for (var i = 0; i < info.form.length; i++) {
          // var str
          if (info.form[i].length > 0 && info.form[i][0].pid == 19) {
            // 会话管理
            for (var a = 0; a < info.form[i].length; a++) {
              for (var b = 0; b < info.form[i][a].permiList.length; b++) {
                if (info.form[i][a].permiList[b].seLect === true) {
                  arr.push(info.form[i][a].permiList[b].id);
                  arr.push(this.titleID[i]);
                }
              }
            }
          } else {
            if (info.form[i].length == 0 || info.form[i].length == undefined) {
              if (info.valueBoo[i] == true) {
                arr.push(this.titleID[i]);
              }
            } else {
              for (var k = 0; k < info.form[i].length; k++) {
                if (info.form[i][k].seLect === true) {
                  // console.log('hhhhhhhhhh',info.form[i],info.form[i][k],info.form[i][k].id)
                  arr.push(info.form[i][k].id);
                  arr.push(this.titleID[i]);
                  // str = this.titleID[i]
                  // console.log("111",this.titleID[i])
                }
              }
            }
          }

          // arr1.push(str)
          // console.log(77777777,str)
        }
        var arr2 = Array.from(new Set(arr));
        console.log("权限数组", arr2);
        this.rolePermission(arr2);
        // 判断是否含有我的同事
        if (arr2.indexOf("23") !== -1) {
          this.$store.state.myColleagueIsShow = true;
          // localStorage.setItem("myColleagueIsShow", true);
        } else {
          this.$store.state.myColleagueIsShow = false;
          // localStorage.setItem("myColleagueIsShow", false);
        }
      }
    },
    confirmEdit(info) {
      this.page = info.page;
      console.log("父组件列表编辑", info);
      if (info.tableName == "employee") {
        this.employeeEdit(info.editForm);
        console.log("员工列表编辑");
      } else if (info.tableName == "roleEdit") {
        console.log("角色列表编辑");
        this.roleEdit(info.editForm);
      } else if (info.tableName == "roleAdd") {
        console.log("角色列表添加");
        this.roleEdit(info.editForm);
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    roleSearch(info) {
      console.log("查询", info);
      if (info.tableName == "employee") {
        this.realName = info.value;
        this.page = 1;
        this.employeeSelect();
        // this.tableDataEmployee=[]
        // this.tableDataEmployee.push(info.item)
        // console.log('tableDataEmployee111111111',this.tableDataEmployee)
      } else if (info.tableName == "role") {
        this.roleName = info.value;
        this.rolePage = 1;
        this.roleSelect();
        // this.tableDataRole = []
        // this.tableDataRole.push(info.item)
        // console.log('tableDataRole',this.tableDataRole)
      }
    },
    roleRestart(info) {
      if (info.tableName == "employee") {
        this.realName = "";
        this.page = 1;
        this.employeeSelect();
      } else if (info.tableName == "role") {
        this.roleName = "";
        this.rolePage = 1;
        this.roleSelect();
      }
    },
    searchFather(info) {
      console.log("查找父部门", info.editForm.depId);
      // console.log("部门列表",this.departmentLst)
      // var ret = this.findTopParents(this.departmentLst, '8defe917136b4faa908e0a72e0e87596');
      // console.log("##################",ret)
    },
    // findTopParents(data, childId) {
    // 	let result
    // 	for(var k=0;k<data.length;k++){
    // 		for (var i = 0; i <data[k].children.length; i++) {
    // 			console.log(111,data[k])
    // 			console.log(222,data[k].children)
    // 			console.log(333,data[k].children[i])
    // 			// let item = data[0].children[i];
    // 			if (item.id == childId) {
    // 				result=data[0].id;
    // 				return result;
    // 			}else if (item.children && item.children.length > 0) {
    // 				result= this.findTopParents(item, childId);
    // 				if(result){
    // 					return result
    // 				}
    // 			}
    // 		}
    // 	}

    // 	return result;
    // },
    clickPage(info) {
      console.log("页码", info);
      if (info.tableName == "employee") {
        this.page = info.page;
        this.employeeSelect();
      } else if (info.tableName == "role") {
        this.rolePage = info.page;
        this.roleSelect();
      }
    },
    open1() {
      const tipMsg = "保存成功 ";
      this.$message.success(tipMsg);
    },
    open2(info) {
      const text = info;
      this.$message.error(text);
    },
    open3() {
      const tipMsg = "删除成功";
      this.$message.success(tipMsg);
    },
  },
};
</script>

<style>
.menu {
  width: 30%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 30px;
  line-height: 30px;
  margin-bottom: 30px;
  font-size: 14px;
}
</style>
